import React from 'react'

const statuses = [
  { color: '#A4D751', label: 'Submitted/Resubmitted' },
  { color: '#92CCF0', label: 'Approved' },
  { color: '#FEC941', label: 'On Hold' },
  { color: '#B2A8D2', label: 'Returned' },
]

const CalendarStatusInfo: React.FC = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-12 items-start">
      {statuses.map((s) => (
        <div key={s.label} className="flex items-center gap-2 w-full sm:w-auto justify-start">
          <span
            className="inline-block w-6 h-6 shrink-0"
            style={{ backgroundColor: s.color }}
            aria-hidden
          />
          <span className="p3 -book text-left">{s.label}</span>
        </div>
      ))}
    </div>
  )
}

export default CalendarStatusInfo
